import useApiQuery from 'shared/hooks/use-api-query';
import {CategoryProps} from '../types';

const useCategoriesByCompany = (companyId?: string) => {
  return useApiQuery<CategoryProps[]>({
    url: `/categories/companies/${companyId}`,
    enabled: !!companyId,
  });
};

export default useCategoriesByCompany;
